import { FC } from 'react';
import Card from '@/components/card';
import { Box, Stack } from '@mui/material';
import CardHeader from '../card/card-header';
import NoneChip from '../chip/none-chip';
import { UsageItem } from './helpers';
import { IconType } from '../icon/helpers';

interface Props {
  title: string;
  items: UsageItem[];
  icon: IconType;
}

const UsageCard: FC<Props> = ({ items, icon, title }) => {
  const hasItems = !!items.length;

  return (
    <Card>
      <CardHeader title={title} icon={icon} />
      <Box>
        {!hasItems && <NoneChip />}
        {hasItems && (
          <Stack gap={1} mt={3}>
            {items.map(({ id, EntityLinkEl }) => {
              return <Box key={id}>{EntityLinkEl}</Box>;
            })}
          </Stack>
        )}
      </Box>
    </Card>
  );
};

export default UsageCard;
